import { Component, Input } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ICustomerParcel } from 'src/app/domain/registration/models/ICustomerParcel';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { CustomerParcelCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { CustomerParcelService } from '../crud-service';

@Component({
  selector: 'app-customer-parcel-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [CustomerParcelService],
})
export class CustomerParcelCrudIndex
  extends AbstractCrudIndex<ICustomerParcel>
  implements ITableResponsive
{
  @Input()
  customerId: string;
  override title = 'AÇÕES DO SISTEMA';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  constructor(
    public override dialog: MatDialog,
    public override service: CustomerParcelService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      dialogConfig: {
        minWidth: '600px',
        maxWidth: '800px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.NEW, customerId: this.customerId, element },
      dialogConfig: {
        minWidth: '800px',
        maxWidth: '1800px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.element) {
          let {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status } = data.element;
          let object: ICustomerParcel = {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status
          };

          this.service.create(Object.assign({}, object)).subscribe(
            () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
            },
            (error) => {
              this.openNew(data.element);
            }
          );
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      dialogConfig: {
        minWidth: '700px',
        maxWidth: '900px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.element?.id) {
          let {
            id,
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          } = data.element;
          let object: ICustomerParcel = {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          };

          this.service.update(id, Object.assign({}, object)).subscribe({
            next: () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
            },
            error: (error) => {
              this.openNew(data.element);
            },
          });
        }

        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }
}
